/* eslint-disable angular/component-name */
angular.module('zc.zenclerkS')
  .component('widgetTopReferrers', {
    templateUrl: '/templates/zenclerk_s/directives/dashboard/top_referrers_widget.html',
    bindings: {
      project: '<',
    },
    controllerAs: 'vm',
    controller: function(ZcsDashboardData) {
      const vm = this;
      const demoData = [
        {
          url: '',
          weeklyData: [{ value: 55 }, { value: 61 }]
        }, {
          url: 'https://www.google.co.jp',
          weeklyData: [{ value: 34 }, { value: 31 }]
        }, {
          url: 'https://www.example-campaign.com',
          weeklyData: [{ value: 32 }, { value: 0 }]
        }, {
          url: 'https://www.yahoo.com',
          weeklyData: [{ value: 16 }, { value: 15 }]
        }, {
          url: 'https://sample-site.com',
          weeklyData: [{ value: 11 }, { value: 11 }]
        }, {
          url: 'https://other-campaign.com/landing-page',
          weeklyData: [{ value: 9 }, { value: 0 }]
        }
      ];

      // variables
      vm.topReferrers = [];

      // actions

      this.$onInit = () => {
        if(vm.project.is_demo) {
          vm.topReferrers = demoData;
        } else {
          ZcsDashboardData.find({
            apikey: vm.project.apikey,
            date: moment().subtract(7, 'days').startOf('day').toDate()
          }).then(res => {
            if(res.top_referrers && res.top_referrers.length > 0) {
              vm.topReferrers = res.top_referrers;
            } else {
              vm.topReferrers = demoData;
              vm.showNoDataOverlay = true;
            }
          });
        }
      };
    }
  });



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/directives/dashboard/top_referrers_widget.js